export default __webpack_public_path__ + "static/media/clip.14c8b092.svg";